import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Card, Flex, HStack, Icon, Separator, Text, VStack, Wrap } from '@chakra-ui/react';
import { SEAT_COMMITMENTS } from '@src/components/sco/Advisors/data/seatIndustries';
import { SpecialtyTag } from '@src/components/sco/Advisors/shared/SpecialtyTag';
import { SeatCategory } from '@src/components/sco/Advisors/types';
import { LuCheck, LuUsers } from 'react-icons/lu';
type CreateSeatPreviewProps = {
  category: SeatCategory | null;
  palette: string;
  industries: string[];
  skills: string[];
  dos: string[];
  commitments: string[];
};

/** Live seat card preview for the create/edit wizard (ADV-G4 extract). */
export const CreateSeatPreview = t0 => {
  const $ = _c(11);
  const {
    category,
    palette,
    industries,
    skills,
    dos,
    commitments
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      lg: "1px"
    };
    t2 = {
      base: 5,
      md: 8
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      lg: "sticky"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text color="colorPalette.fg/50" textAlign="center" textStyle="labelXs">Your board seat</Text>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== category || $[5] !== commitments || $[6] !== dos || $[7] !== industries || $[8] !== palette || $[9] !== skills) {
    t5 = <Box bgColor="colorPalette.panel" borderColor="colorPalette.border/30" borderLeftWidth={t1} padding={t2}><VStack align="stretch" gap={3} marginX="auto" maxWidth="sm" position={t3} top={0}>{t4}{!category ? <Card.Root borderStyle="dashed" minHeight="320px" variant="outline"><Card.Body alignItems="center" gap={3} justifyContent="center" textAlign="center"><Flex align="center" borderColor="colorPalette.border" borderRadius="full" borderStyle="dashed" borderWidth="2px" boxSize={12} justify="center"><Icon boxSize={5} color="colorPalette.fg/40"><LuUsers /></Icon></Flex><Text color="colorPalette.fg/50" fontSize="sm" maxWidth="2xs">Pick a category and your board seat will take shape here as you build it.</Text></Card.Body></Card.Root> : <Card.Root borderRadius="xl" overflow="hidden" variant="subtle"><Card.Body gap={4}><HStack gap={2}><Icon boxSize={5} color={`${palette}.fg`}><category.icon /></Icon><Text color={`${palette}.fg`} fontSize="sm" fontWeight="semibold">{category.name}</Text></HStack>{industries.length > 0 && <VStack align="stretch" gap={2}><Text color="colorPalette.fg/50" textStyle="label2xs">Industry</Text><Wrap gap={1.5}>{industries.map(i => <Badge key={i} colorPalette={palette} textStyle="label2xs" variant="subtle">{i}</Badge>)}</Wrap></VStack>}<Separator /><VStack align="stretch" gap={2}><Text color="colorPalette.fg/50" textStyle="label2xs">Skills</Text>{skills.length ? <Wrap gap={1.5}>{skills.map(s => <SpecialtyTag key={s} colorPalette={palette} label={s} />)}</Wrap> : <Text color="colorPalette.fg/40" fontSize="xs">Skills you pick appear here</Text>}<Text color="colorPalette.fg/70" fontFamily="longform" fontSize="sm">{category.role}</Text></VStack><Separator /><VStack align="stretch" gap={2}><Text color="colorPalette.fg/50" textStyle="label2xs">What they'll do</Text>{dos.length ? dos.map(_temp) : <Text color="colorPalette.fg/40" fontSize="xs">What you want them to do appears here</Text>}</VStack>{commitments.length > 0 && <Separator />}{commitments.length > 0 && <VStack align="stretch" gap={2}><Text color="colorPalette.fg/50" textStyle="label2xs">Time commitment</Text>{commitments.map(_temp2)}</VStack>}</Card.Body></Card.Root>}</VStack></Box>;
    $[4] = category;
    $[5] = commitments;
    $[6] = dos;
    $[7] = industries;
    $[8] = palette;
    $[9] = skills;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(d) {
  return <HStack key={d} align="flex-start" gap={2}><Icon boxSize={4} color="green.fg" marginTop={0.5}><LuCheck /></Icon><Text fontSize="sm">{d}</Text></HStack>;
}
function _temp2(key) {
  return <HStack key={key} gap={2}><Box bgColor="teal.solid" borderRadius="full" boxSize={1.5} /><Text fontSize="sm">{SEAT_COMMITMENTS.find(c => c.key === key)?.label ?? key}</Text></HStack>;
}